// @ts-nocheck
/* eslint-disable */
export const appHamburgerMenu32Icon = {
    data: `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 9H28" stroke="currentColor" stroke-width="2.5"/><path d="M4 16H28" stroke="currentColor" stroke-width="2.5"/><path d="M4 23H28" stroke="currentColor" stroke-width="2.5"/></svg>`,
    name: 'hamburger-menu-32' as const
};